export default __webpack_public_path__ + "static/crispin-glover-d5b2b0f3a1bbca57443f15e914ade270.svg";